// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__UiQ94","active":"Pagination_active__NpiWU","hidden":"Pagination_hidden__qloSd"};